<div class="modal-content">
  <div class="modal-header">
    <i aria-label="Close" (click)="handleClick({ close: true })" class="close pull-right align-middle fas fa-times"> </i>
    <p class="modal-title h4" jhiTranslate="MODAL_CHANGE_INSURANCE_ITEMS_ORDER.TITLE"></p>
  </div>
  <form>
    <div class="modal-body text-left">
      <div class="row" *ngIf="model">
        <div class="col-12 pb-2">
          <span class="color-gray font-weight-bold" jhiTranslate="MODAL_CHANGE_INSURANCE_ITEMS_ORDER.SUBTITLE"></span>
        </div>
        <div class="col-12">
          <jhi-bary-sortable-list [showPosition]="true" [labelField]="labelField" [items]="model"></jhi-bary-sortable-list>
        </div>
      </div>
    </div>
    <div class="modal-footer justify-content-end">
      <div class="row">
        <div class="col-auto">
          <jhi-bary-button [outline]="true" color="primary" [label]="'BTN.CANCEL' | translate" (clickEvent)="handleClick({ cancel: true })"></jhi-bary-button>
        </div>
        <div class="col-auto">
          <jhi-bary-button (clickEvent)="handleSubmit()" [label]="'BTN.CONFIRM' | translate" color="primary"></jhi-bary-button>
        </div>
      </div>
    </div>
  </form>
</div>
